import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-display-collapsible-text-view',
    templateUrl: './his-display-collapsible-text-view.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayCollapsibleTextViewComponent {
    static readonly MAX_TEXT_LENGTH = 620;

    @Input() text: string;
    @Input() header = '';
    @Input() expandToolTip = '';
    @Input() collapseToolTip = '';
    @Input() hisobject: any;
    @Input() hisAttribute: string;

    public showFullText = false;
    public maxLength = HisDisplayCollapsibleTextViewComponent.MAX_TEXT_LENGTH;

    /* set to show the full/shortened text */
    public setShowFullText( showFullText: boolean ): void {
        this.showFullText = showFullText;
    }

    /* compares the text.length to the specified maximum */
    public isMaxTextLength(): boolean {
        return this.text && this.text.length > HisDisplayCollapsibleTextViewComponent.MAX_TEXT_LENGTH;
    }

    /* substring text to max 620 or last full word */
    public getMaxTextLength( text: string ): string {
        let textLength = HisDisplayCollapsibleTextViewComponent.MAX_TEXT_LENGTH;
        while ( ( text.charAt( textLength ) !== ' '
            || text?.charAt( textLength ).match( '\n' ) ) && textLength !== 0 ) {
            textLength--;
        }
        return text.substring( 0, textLength ) + ' ...';
    }
}
